import { ArrayDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
export class UitpasNumbersGetDetailsRequest {
    constructor(data) {
        this.uitpasNumbers = data.uitpasNumbers;
    }
    static decode(data) {
        return new UitpasNumbersGetDetailsRequest({
            uitpasNumbers: data.field('uitpasNumbers').decode(UitpasNumbersDecoder),
        });
    }
    encode(_context) {
        return {
            uitpasNumbers: JSON.stringify(this.uitpasNumbers),
        };
    }
}
class UitpasNumbersDecoder {
    static decode(data) {
        const str = data.string;
        try {
            const decoded = JSON.parse(str);
            return (new ArrayDecoder(StringDecoder)).decode(data.clone({ data: decoded, field: data.currentField, context: data.context }));
        }
        catch (e) {
            throw new SimpleError({
                code: 'invalid_field',
                message: `Expected JSON at ${data.currentField}`,
                field: data.currentField,
            });
        }
    }
}
//# sourceMappingURL=UitpasNumbersGetDetailsRequest.js.map